import services from '../services'
import * as types from './mutation-types'

export const GetFinancialSettings = ({ commit }) => (
  services.getFinancialSettings().then(res => {
    commit(types.SET_SETTINGS, res.data.data)
    return res.data.data
  })
)

export const SaveFinancialSettings = ({ commit }, payload) => (
  services.saveFinancialSettings(payload).then(res => {
    commit(types.SET_SETTINGS, res.data.data)
    return res.data.data
  })
)
